import type { Condition } from '@inixiative/json-rules';
import { isSameConditionTree } from './canonicalConditionKey';

// gloss
export const ruleRequirements = (rules: Condition | null | undefined): Condition[] => {
  if (rules == null || typeof rules === 'boolean') return [];
  if ('all' in rules && Array.isArray(rules.all)) return rules.all;
  return [rules];
};

const isAllGroup = (condition: Condition | undefined): boolean =>
  condition != null && typeof condition === 'object' && 'all' in condition && Array.isArray(condition.all);

// gloss
export const joinRuleRequirements = (requirements: Condition[]): Condition | null => {
  if (requirements.length === 0) return null;
  const [only] = requirements;
  return requirements.length === 1 && !isAllGroup(only) ? (only ?? null) : { all: requirements };
};

// gloss
export const withoutRuleRequirement = (rules: Condition | null | undefined, index: number): Condition | null =>
  joinRuleRequirements(ruleRequirements(rules).filter((_, position) => position !== index));

// gloss
export const hasRuleRequirement = (rules: Condition | null | undefined, requirement: Condition): boolean =>
  ruleRequirements(rules).some((held) => isSameConditionTree(held, requirement));

// gloss
export const withRuleRequirement = (
  rules: Condition | null | undefined,
  requirement: Condition,
  isHeld: boolean,
): Condition | null => {
  if (rules === false) return false;
  const rest = ruleRequirements(rules).filter((held) => !isSameConditionTree(held, requirement));
  return joinRuleRequirements(isHeld ? [...rest, requirement] : rest);
};
